import React from 'react';
import type { RelatedVendorCard } from '../constants';
import { VENDOR_TAG_COLOR } from '../constants';

const DEFAULT_TAG_COLOR = { bg: '#f0f1f2', color: '#394766' };

/** 关联供应商卡片：供应商名（蓝）+ 标签（按 tagLevel 着色：1/2 红、3/4 橙） */
const VendorCard = ({ vendor }: { vendor: RelatedVendorCard }) => {
  const tags = vendor.tags?.length
    ? vendor.tags
    : vendor.desc
      ? [{ label: vendor.desc, tagLevel: vendor.tagLevel }]
      : [];

  return (
    <div className="w-[500px] rounded-[6px] border border-solid border-[#c1c6d1] p-3">
      <p className="text-[14px] font-semibold leading-[22px] text-[#1c80eb]">
        {vendor.vendorName || '--'}
      </p>
      {tags.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2">
          {tags.map((t, i) => {
            const c = VENDOR_TAG_COLOR[String(t.tagLevel)] ?? DEFAULT_TAG_COLOR;
            return (
              <span
                key={i}
                className="inline-flex items-center rounded-[4px] px-2 py-0.5 text-[12px] leading-[18px]"
                style={{ backgroundColor: c.bg, color: c.color }}>
                {t.label}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default VendorCard;
